<template>
  <div class="not-found">
    <div class="container">
      <div class="not-found-content">
        <div class="error-code">404</div>
        <h1 class="error-title">{{ $t('notFound.title') }}</h1>
        <p class="error-desc">{{ $t('notFound.description') }}</p>
        <el-button type="primary" @click="goToHome">{{ $t('notFound.backHome') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'

export default {
  name: 'NotFoundView',
  setup() {
    const router = useRouter()
    
    const goToHome = () => {
      router.push('/')
    }
    
    return {
      goToHome
    }
  }
}
</script>

<style scoped>
.not-found {
  padding: 100px 0;
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.not-found-content {
  text-align: center;
}

.error-code {
  font-size: 120px;
  font-weight: 700;
  color: #409EFF;
  line-height: 1;
  margin-bottom: 20px;
}

.error-title {
  font-size: 32px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
}

.error-desc {
  font-size: 18px;
  color: #606266;
  margin-bottom: 30px;
}
</style> 